import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    OnInit,
    signal,
} from '@angular/core';
import { TelXLButtonComponent, TelXLTabComponent } from '@dxp/elements';
import { IActiveAgentDirectoryEvent, ITab } from '@dxp/core/models';
import { CommonModule } from '@angular/common';
import { TelXLActiveAgentDirectoryPanelComponent } from '../directory-listing/active-agent-directory/active-agent-directory-panel.component';
import { TelXLOverlayComponent } from '../overlay/overlay.component';
import { OverlayRef } from '../overlay/overlay.ref';
import { TelXLTransferQueueComponent } from './transfer-queue/transfer-queue.component';

@Component({
    selector: 'telxl-shared-conversation-transfer',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        TelXLOverlayComponent,
        TelXLTabComponent,
        TelXLButtonComponent,
        TelXLTransferQueueComponent,
        TelXLActiveAgentDirectoryPanelComponent,
    ],
    templateUrl: './conversation-transfer-panel.component.html',
    styleUrl: './conversation-transfer-panel.component.scss',
})
export class TelXLConversationTransferPanelComponent implements OnInit {
    readonly #overlayRef = inject(
        OverlayRef<{ queue?: string; agent?: string }>,
    );

    businessUnitId = input<string | null>(null);
    conversationId = input.required<string>();
    queueId = input.required<string>();
    agentId = input.required<string>();
    targets = input.required<('Queue' | 'Agent')[]>();
    target = input<'queues' | 'agents'>();

    readonly selected = signal<string>('queues');

    tabs = computed<ITab[]>(() => {
        const tabs = [];

        if (this.targets().includes('Queue')) {
            tabs.push({ label: 'Queues', index: 'queues' });
        }

        if (this.targets().includes('Agent')) {
            tabs.push({ label: 'Agents', index: 'agents' });
        }

        return tabs;
    });

    ngOnInit() {
        if (this.target()) this.selected.set(this.target() as string);
    }

    close() {
        this.#overlayRef.close({});
    }

    transferToQueue(queueId: string) {
        this.#overlayRef.close({ queue: queueId });
    }

    setSelected(tab: string) {
        this.selected.set(tab);
    }

    transferToAgent(event: IActiveAgentDirectoryEvent) {
        this.#overlayRef.close({ agent: event.item.id });
    }
}
